<form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
  <h3 class="step-title">Authorized Representative</h3>
  <p class="step-subtitle">
    We need details about the primary person responsible for this organization.
    This information is used for identity verification and is stored securely.
  </p>

  <div class="form-row two-col">
    <mat-form-field appearance="outline">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstName">
      <mat-error *ngIf="form.get('firstName')?.hasError('required')">First name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName">
      <mat-error *ngIf="form.get('lastName')?.hasError('required')">Last name is required</mat-error>
    </mat-form-field>
  </div>

  <div class="form-row two-col">
    <mat-form-field appearance="outline">
      <mat-label>Email Address</mat-label>
      <input matInput formControlName="email" type="email" readonly>
      <mat-hint title="This is the email you used to start the onboarding process and cannot be changed here">
        Auto-populated from your account
      </mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Phone Number</mat-label>
      <input matInput formControlName="phone" placeholder="+1 (555) 000-0000">
      <mat-error *ngIf="form.get('phone')?.hasError('required')">Phone is required</mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Title / Role</mat-label>
      <mat-select formControlName="title">
        <mat-option *ngFor="let t of titles" [value]="t.value">{{ t.label }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required</mat-error>
    </mat-form-field>
  </div>

  <div class="section-divider"><span>Date of Birth</span></div>

  <div class="form-row three-col">
    <mat-form-field appearance="outline">
      <mat-label>Month</mat-label>
      <mat-select formControlName="dobMonth">
        <mat-option *ngFor="let m of months" [value]="m.v">{{ m.l }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('dobMonth')?.hasError('required')">Month required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Day</mat-label>
      <mat-select formControlName="dobDay">
        <mat-option *ngFor="let d of days" [value]="d">{{ d }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('dobDay')?.hasError('required')">Day required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Year</mat-label>
      <mat-select formControlName="dobYear">
        <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('dobYear')?.hasError('required')">Year required</mat-error>
    </mat-form-field>
  </div>

  <div class="section-divider"><span>Home Address</span></div>

  <div class="form-row">
    <app-address-autocomplete formControlName="addressLookup" class="full-width"></app-address-autocomplete>
  </div>

  <!-- Hidden fields for form submission — auto-populated by address lookup -->
  <input formControlName="addrLine1" style="display:none">
  <input formControlName="addrCity" style="display:none">
  <input formControlName="addrState" style="display:none">
  <input formControlName="addrZip" style="display:none">

  <div class="section-divider"><span>Identity Verification</span></div>

  <div class="ssn-note">
    <mat-icon class="note-icon">lock</mat-icon>
    <p>
      Your SSN is required by Stripe for identity verification under US financial regulations.
      Only the last 4 digits are stored; the full number is sent securely to Stripe and never stored by Chareety.
    </p>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="ssn-field">
      <mat-label>SSN Last 4 Digits</mat-label>
      <input matInput formControlName="ssnLast4" placeholder="XXXX" maxlength="4" inputmode="numeric">
      <mat-error *ngIf="form.get('ssnLast4')?.hasError('required')">SSN last 4 digits required</mat-error>
      <mat-error *ngIf="form.get('ssnLast4')?.hasError('pattern')">Must be exactly 4 digits</mat-error>
    </mat-form-field>
  </div>

  <div class="form-actions">
    <button mat-raised-button color="primary" type="submit" [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="20" class="btn-spinner"></mat-spinner>
      <span>{{ loading ? 'Saving...' : 'Save & Continue' }}</span>
    </button>
  </div>
</form>
